import thor from '../services/thor';

import { CustomEventService, IEvents, TEventBody } from './customEvent';

const TrackingService = {
    sendEvent: (eventPayload: TEventBody) => {
        if (eventPayload.detail) {
            thor.pushEvent(eventPayload.detail.name, eventPayload.detail.data);
        }
    },
    setDatalayer: (dataLayerPayload: TEventBody) => {
        if (dataLayerPayload.detail) {
            thor.pushVariable(dataLayerPayload.detail);
        }
    },
    initTracking: () => {
        if (process.env.NX_TASK_TARGET_CONFIGURATION === 'development') {
            thor.checkTesting();
        }

        // User centrics or Didomi consent
        const userConsentInterval = setInterval(() => {
            // as long as the user has not interact with the cookie banner, needUserInteraction is true
            let needUserInteraction;
            if (typeof window.UC_UI?.isConsentRequired === 'function') {
                needUserInteraction = window.UC_UI.isConsentRequired();
            }
            if (typeof window.Didomi?.shouldConsentBeCollected === 'function') {
                needUserInteraction = window.Didomi.shouldConsentBeCollected();
            }

            if (needUserInteraction === false) {
                clearInterval(userConsentInterval);
                thor.onConsent();
            }
        }, 1000);

        CustomEventService.subscribe(IEvents.SET_DATALAYER, TrackingService.setDatalayer);
        CustomEventService.subscribe(IEvents.SEND_TRACKING_EVENT, TrackingService.sendEvent);
        CustomEventService.subscribe(IEvents.SEND_PAGE_VIEW, TrackingService.sendEvent);

        return () => {
            CustomEventService.unsubscribe(IEvents.SET_DATALAYER, TrackingService.setDatalayer);
            CustomEventService.unsubscribe(IEvents.SEND_TRACKING_EVENT, TrackingService.sendEvent);
            CustomEventService.unsubscribe(IEvents.SEND_PAGE_VIEW, TrackingService.sendEvent);
            clearInterval(userConsentInterval);
        };
    },
};

export default TrackingService;
